import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, computed, inject, input } from '@angular/core';
import { ChatInputService } from '@app/services/chat-input.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';
import { Chip } from 'primeng/chip';

@Component({
  selector: 'app-chat-input-suggestions',
  templateUrl: './chat-input-suggestions.component.html',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, TranslocoPipe, Button, Chip],
})
export class ChatInputSuggestionsComponent {
  tabId = input<string>();

  chatInputService = inject(ChatInputService);

  suggestions = computed(() => this.chatInputService.getSuggestions(this.tabId()));
  suggestionsAvailable = computed(() => {
    const suggestions = this.chatInputService.getSuggestions(this.tabId());
    return suggestions && suggestions.length > 0;
  });

  postSuggestion(suggestion: string): void {
    this.chatInputService.setChatInput(this.tabId(), suggestion);
  }

  closeSuggestions() {
    this.chatInputService.clearSuggestions(this.tabId());
  }
}
